import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useEffect } from 'react';

import { useJwtPayload } from '@/core/store/auth/authSelectors';

const dimensionId = Number(import.meta.env.VITE_MATOMO_COMPANY_DIMENSION_ID);

export const useTrackMatomoCompanyId = (): void => {
	const companyId = useJwtPayload()?.['custom:company_uuid'] ?? null;
	const { pushInstruction } = useMatomo();

	useEffect(() => {
		if (!dimensionId) return;

		if (companyId) {
			pushInstruction('setCustomDimension', dimensionId, companyId);
		} else {
			pushInstruction('deleteCustomDimension', dimensionId);
		}
	}, [companyId, pushInstruction]);
};
